import { EProductTourTargets } from '@constants';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  ShowMoreButton,
  ShowMoreButtonMobile,
  TitleWrapper,
  WidgetTitle,
  WidgetWrapper
} from '../shared/WidgetShared.styles';

import { CoursesWrapper } from './SubscriptionsWidget.styles';

import { SubscriptionCard } from '@/components/SubscriptionSelectionModal';
import { useIsMobile } from '@/hooks';
import { useMySubscriptions } from '@/store';

export const SubscriptionsWidget: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const navigateTo = useNavigate();
  const isMobile = useIsMobile();

  const { filteredSubscriptions, lastFourSubscriptions } = useMySubscriptions();
  const handleChangeCourse = () => {
    navigateTo('/subscription/courses');
  };
  if (!filteredSubscriptions || filteredSubscriptions.length <= 1) return null;

  const showedSubscriptions =
    lastFourSubscriptions.length < 2 ? filteredSubscriptions?.slice(0, 4) : lastFourSubscriptions;

  return (
    <WidgetWrapper id={EProductTourTargets.SUBSCRIPTIONS_WIDGET}>
      <TitleWrapper>
        <WidgetTitle>{t('MY_FEATURED_COURSES')}</WidgetTitle>
        {!isMobile && (
          <ShowMoreButton type="text" onClick={handleChangeCourse}>
            {t('SEE_ALL')}
          </ShowMoreButton>
        )}
      </TitleWrapper>

      <CoursesWrapper>
        {showedSubscriptions.map(subscription => (
          <SubscriptionCard key={subscription._id} subscription={subscription} />
        ))}
      </CoursesWrapper>

      {isMobile && (
        <ShowMoreButtonMobile onClick={handleChangeCourse}>
          <Button type="text">
            <span>{t('SEE_ALL_COURSES')}</span>
          </Button>
        </ShowMoreButtonMobile>
      )}
    </WidgetWrapper>
  );
};
